import React from "react";
import { Button, Typography } from "@material-ui/core";
import GenericDialog from "../components/dialog/GenericDialog";
interface AdminOverrideDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const AdminOverrideDialog: React.FC<AdminOverrideDialogProps> = ({ open, onClose, onConfirm }) => {
    return (
            <GenericDialog
                    open={open}
                    onClose={onClose}
                    title="Admin Override for Wet Sign"
                    titleVariant="h6"
                    actions={
                        <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: '16px', // spacing between buttons
                                    padding: '8px 0',
                                }}
                        >
                            <Button
                                    onClick={onConfirm}
                                    variant="contained"
                                    style={{ backgroundColor: '#d32f2f', color: '#fff' }} // Red Yes
                            >
                                Yes
                            </Button>
                            <Button
                                    onClick={onClose}
                                    variant="contained"
                                    color="primary" // Blue No
                            >
                                No
                            </Button>
                        </div>
                    }
            >
                <Typography variant="body1">
                    Are you sure you want to approve this request?
                </Typography>
            </GenericDialog>
    );
};


export default AdminOverrideDialog;